<template>
  <div>
    <div class="box pt-60 pl-80 pr-80 pb-90">
      <div class="page-tab pt-26 df aic">
        <span class="ip1 cup" @click="handleStationed('/stationed/index')">{{ $t('驻站专家') }}</span>
        <span class="active ml-22">MVP</span>
      </div>
      <div class="card1">
        <div class="t1">MOST VALUABLE</div>
        <div class="t2">
          <span class="s1">OceanClub</span>
          <span class="s2">{{ $t('最佳价值专家') }}</span>
        </div>
        <div class="desc">
          {{ $t('MVP 是社区授予的最高荣誉,是年度评选的OceanClub社区最佳价值专家。他们不仅在行业拥有深厚专业背景和实践经验,而且在社区中发挥引领作用,积极推动知识分享和技术交流,为数据存储技术和创新应用落地提供经典范例和实践指导。MVP不仅是推动社区繁荣的中坚力量,更是数据存储行业领航者和技术先行者,他们以卓越的洞察力和领导力,塑造着未来发展方向。')}}
        </div>
      </div>

      <div class="cars2">
        <div class="t1">- {{ $t('欢迎成为最佳价值专家') }} -</div>
        <div class="t2">{{ $t('MVP权益') }}</div>

        <div class="card2-box mt-30">
          <div class="li-box df jcsb">
            <div class="li f1 ta-c">
              <div class="img-box">
                <div class="img-li">
                  <img :src="require('../../assets/images/img/s1.png')" alt="">
                </div>

                <p class="ta-c break-word">{{ $t('MVP专属奖杯及证书') }} </p>
              </div>
            </div>
            <div class="li f1 ta-c">
              <div class="img-box">
                <div class="img-li">
                  <img :src="require('../../assets/images/img/s2.png')" alt="">
                </div>
                <p class="ta-c break-word">{{ $t('专属MVP颁奖盛典') }} </p>
              </div>
            </div>
            <div class="li f1 ta-c">
              <div class="img-box">
                <div class="img-li">
                  <img :src="require('../../assets/images/img/s3.png')" alt="">
                </div>

                <p class="ta-c break-word">{{ $t('媒体采访') }}</p>
              </div>
            </div>
            <div class="li f1 ta-c">
              <div class="img-box">
                <div class="img-li">
                  <img :src="require('../../assets/images/img/s5.png')" alt="">
                </div>

                <p class="ta-c break-word">{{ $t('社区网站展示') }} </p>
              </div>
            </div>
            <div class="li f1 ta-c">
              <div class="img-box">
                <div class="img-li">
                  <img :src="require('../../assets/images/img/s4.png')" alt="">
                </div>

                <p class="ta-c break-word">{{ $t('参观企业实验室') }}</p>
              </div>
            </div>
            <div class="li f1 ta-c">
              <div class="img-box">
                <div class="img-li">
                  <img :src="require('../../assets/images/img/s6.png')" alt="">
                </div>

                <p class="ta-c break-word">{{ $t('高端技术圈层活动') }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="card3">
      <div class="t1s">{{ $t('如何成为MVP?') }}</div>

      <div class="card3-box pt-56 df jcsa">
        <div class="li">
          <img src="@/assets/images/img/mvp-img1.png" alt="">
          <p class="t1">{{ $t('社区贡献') }}</p>
          <div class="t2" style="max-width: 360px;">
            <p>{{ $t('通过发帖、互动、参加线上线下活动、演讲、写文章等获得积分') }}</p>
          </div>
        </div>
        <div class="li">
          <img src="@/assets/images/img/mvp-img2.png" alt="">
          <p class="t1">{{ $t('行业经验') }}</p>
          <div class="t2" style="max-width: 400px;">
            <p>{{ $t('存储行业从业资历') }}</p>
            <p>{{ $t('获得IT领域高级认证证书') }}</p>
          </div>
        </div>
        <div class="li">
          <img src="@/assets/images/img/mvp-img3.png" alt="">
          <p class="t1">{{ $t('项目经验') }}</p>
          <div class="t2" style="max-width: 460px;">
            <p>{{ $t('参与社区合作伙伴的数据存储项目') }}</p>
            <p>{{ $t('为社区会员分享项目经验') }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {

  methods: {
    handleStationed(path) {
      let str = '/cn';
      let Language = localStorage.getItem('currentLanguage');  //获取本地语言
      if (Language && Language != 'zh') {
        str = '/' + Language;
      }
      this.$router.push(str + path); // 使用编程式导航跳转到 About 页面
    }
  }
}
</script>

<style lang="scss" scoped>
.card3 {
  background-image: url("../../assets/images/img/mvp-cardbt.png");
  background-size: 100% auto;
  background-position: bottom center;
  padding-bottom: 206px;

  .li {
    text-align: center;
    min-width: 360px;
  }

  .t1s {
    text-align: center;
    color: rgb(18, 18, 18);
    font-family: "MicrosoftYaHeiSemibold";
    font-size: 32px;
    font-weight: 400;
    line-height: 60px;

  }

  .t1 {
    color: rgb(18, 18, 18);
    font-family: "MicrosoftYaHeiSemibold";
    font-size: 28px;
    font-weight: 400;
    line-height: 28px;
    margin-top: 40px;
  }

  .t2 {
    color: rgb(18, 18, 18);
    font-size: 16px;
    font-weight: 400;
    line-height: 24px;
    margin-top: 20px;
  }
}

.card2-box {
  padding-bottom: 80px;

  .li {
    img {
      width: 200px;
    }

    p.ta-c {
      color: rgb(18, 18, 18);
      font-family: "MicrosoftYaHeiSemibold";
      font-size: 20px;
      font-weight: 400;
      line-height: 28px;
      margin-top: 6px;
    }
  }
}

.cars2 {
  padding-top: 75px;

  .t1 {
    color: rgb(18, 18, 18);
    font-family: "MicrosoftYaHeiSemibold";
    font-size: 44px;
    font-weight: 400;
    line-height: 60px;
    text-align: center;
  }

  .t2 {
    text-align: center;
    color: rgb(18, 18, 18);
    font-family: "MicrosoftYaHeiSemibold";
    font-size: 32px;
    font-weight: 400;
    line-height: 60px;
    margin-top: 68px;
  }
}

.card1 {
  height: 600px;
  background-image: url("../../assets/images/mvp-bg.png");
  background-size: cover;
  background-position: left center;
  margin-top: 24px;

  padding: 60px;

  .t1 {
    color: rgb(98, 98, 98);
    font-family: "PingFang-SC";
    font-size: 30px;
    font-weight: 400;
    line-height: 45px;
  }

  .t2 {
    font-family: "PingFang-SC";
    font-size: 68px;
    font-weight: 400;
    line-height: 102px;
    letter-spacing: 2px;
    margin-top: 100px;

    .s1 {
      color: #191919;
    }

    .s2 {
      color: #B7251E;
    }
  }

  .desc {
    max-width: 1389px;

    color: rgb(84, 84, 84);
    font-family: "PingFang-SC";
    font-size: 18px;
    font-weight: 400;
    line-height: 32px;
    letter-spacing: 2px;
    margin-top: 9px;
  }
}

.box {

  .page-tab {
    span {
      width: 208px;
      height: 52px;
      line-height: 52px;
      border: 1px solid rgb(217, 217, 217);
      border-radius: 4px;
      padding-left: 20px;
    }

    .ip1 {
      padding-left: 54px;

      border: 1px solid rgb(217, 217, 217);
      border-radius: 50px 4px 4px 4px;
      position: relative;

      &::after {
        content: "";
        display: block;
        width: calc(100% + 0px);
        height: calc(100% + 0px);
        border-radius: 50px 4px 4px 4px;
        border: 1px solid #B7251E;
        position: absolute;
        left: 0px;
        top: 0px;
        opacity: 0;
        transition: all .26s;

      }

      &::before {
        content: "";
        display: inline-block;
        width: 2px;
        height: 16px;
        border-radius: 1px;
        background: rgb(183, 37, 30);
        margin-right: 8px;
        position: relative;
        top: 1px;
      }

    }

    .ip1:hover {
      &::after {
        content: "";
        opacity: 1;
        width: calc(100% + 6px);
        height: calc(100% + 6px);
        left: -4px;
        top: -4px;
      }
    }

    span.active {
      width: 208px;
      height: 58px;
      border: none;
      background-image: url("../../assets/images/tab1-bg.png");
      background-size: 100% 100%;
      padding-left: 44px;
      color: #FFFFFF;
      line-height: 56px;
    }
  }
}
</style>